import {
  CalendarIcon,
  ComponentIcon,
  EpicIcon,
  FlagIcon,
  ReleaseIcon,
  StatusIcon,
  UserIcon,
} from "app/components/Icons";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import React from "react";
import { getDueDateLabel } from "utils/helpers";
import { GroupByTypeEnum } from "../../../../types";
import TagsPreview from "./TagsPreview";
import { IGroupHeaderMeta, TicketGroup } from "../../../Tickets/types";

interface Props {
  group: TicketGroup;
  subGroupBy: GroupByTypeEnum;
  meta: IGroupHeaderMeta;
}

const SubGroupLabel: React.FC<Props> = ({ group, subGroupBy, meta }) => {
  const { ticketType, selectedStatus, tagsObj, selectedPriority } = meta;

  const wrapper = `flex items-center gap-2 `;

  switch (subGroupBy) {
    case GroupByTypeEnum.ASSIGNEE:
      return group._id ? (
        <MemberProfileAvatar
          id={group._id}
          circleClassName="!w-6 !h-6"
          nameClassName="!font-medium text-secondary "
        />
      ) : (
        <div className={wrapper}>
          <UserIcon color="#79808A" />
          <span className="text-sm font-medium text-secondary ">
            Unassigned
          </span>
        </div>
      );

    case GroupByTypeEnum.TAGS:
      return (
        <TagsPreview
          tags={tagsObj}
          visibleCount={2}
          className=" text-secondary"
        />
      );

    case GroupByTypeEnum.TICKET_TYPE:
      return ticketType ? (
        <div className={wrapper}>
          <TicketTypeIcon iconName={ticketType.icon} />
          <span className="text-sm font-medium">{ticketType.name}</span>
        </div>
      ) : (
        <span className="text-sm font-medium">No Ticket Type</span>
      );

    case GroupByTypeEnum.STATUS:
      return selectedStatus ? (
        <div className={wrapper}>
          <StatusIcon color={selectedStatus.color} />
          <span className="text-sm font-medium text-secondary">
            {selectedStatus.name}
          </span>
        </div>
      ) : (
        <span className="text-sm font-medium text-secondary ">No Status</span>
      );

    case GroupByTypeEnum.PRIORITY:
      return selectedPriority ? (
        <div className={wrapper}>
          <FlagIcon size={16} color={selectedPriority.color} />
          <span className="text-sm font-medium text-secondary">
            {selectedPriority.label}
          </span>
        </div>
      ) : (
        <div className={wrapper}>
          <FlagIcon size={16} color="#79808A" />
          <span className={`text-sm font-medium text-secondary`}>
            No Priority
          </span>
        </div>
      );
    case GroupByTypeEnum.DUE_DATE:
      return (
        <div className={wrapper}>
          <CalendarIcon size={20} color="#79808A" />
          <span className="text-sm font-medium truncate max-w-[130px]">
            {getDueDateLabel(group._id)}
          </span>
        </div>
      );
    case GroupByTypeEnum.EPIC:
      return (
        <div className={wrapper}>
          <EpicIcon size={20} color="#79808A" />
          <span className="text-sm font-medium truncate max-w-[130px]">
            {group._id.length > 0 ? group._id : "No Epic"}
          </span>
        </div>
      );
    case GroupByTypeEnum.COMPONENT:
      return (
        <div className={wrapper}>
          <ComponentIcon size={20} color="#79808A" />
          <span className="text-sm font-medium truncate max-w-[130px]">
            {group._id.length > 0 ? group._id : "No Component"}
          </span>
        </div>
      );
    case GroupByTypeEnum.RELEASE:
      return (
        <div className={wrapper}>
          <ReleaseIcon size={20} color="#79808A" />
          <span className="text-sm font-medium truncate max-w-[130px]">
            {group._id.length > 0 ? group._id : "No Release"}
          </span>
        </div>
      );

    default:
      return <span className="text-sm font-medium">{group._id}</span>;
  }
};

export default React.memo(SubGroupLabel);
